// extracted by mini-css-extract-plugin
module.exports = {"warn":"style_warn__3xk9l","info":"style_info__9Un7k","center":"style_center__tjtXv","imageBox":"style_imageBox__3lR-B"};